import React, { useState, useEffect, useRef } from "react"
import VisibilitySensor from "react-visibility-sensor"
import AppendixItems from "../data/appendix.json"
import IconAppendix from "../images/appendix.inline.svg"
import IconClose from "../images/close.inline.svg"
import IconExternalLink from "../components/svg/icon-external-link"
import Modal from "react-modal"
import { toast } from "react-toastify"
import slugify from "slugify"

Modal.setAppElement("#___gatsby")

export const Appendix = ({ page }) => {
  const [active, setActive] = useState(false)
  const appendixButton = useRef()

  const toggleOverlay = () => {
    setActive(!active)
    toast.dismiss()
  }

  const pageData = AppendixItems.find(obj => {
    return obj.page === page
  })

  // Simple listener to close overlay on escape key hit
  function handleKeydown(e) {
    if (e.keyCode === 27 && active) {
      toggleOverlay()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown)
    return () => {
      document.removeEventListener("keydown", handleKeydown)
    }
  })

  return (
    <>
      <Modal
        isOpen={active}
        overlayClassName="overlay appendix__overlay"
        className="overlay__content"
        bodyOpenClassName="util__body-lock"
      >
        <header>
          <h3 className="title--xl md:title--xxl util__text-centered">
            Further Reading
          </h3>
        </header>
        <ul>
          {pageData.items.map((item, index) => {
            return (
              <li key={index}>
                <a href={item.href}>
                  <IconExternalLink />
                  <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
                </a>
              </li>
            )
          })}
        </ul>

        <button
          className="appendix__button appendix__button--active"
          aria-label="Close Further Reading list"
          onClick={toggleOverlay}
          aria-haspopup="true"
          aria-owns="appendix__overlay"
        >
          <IconClose />
        </button>
      </Modal>

      <div className="appendix">
        {!active && (
          <button
            ref={appendixButton}
            className="appendix__button"
            aria-label="Open Further Reading list"
            onClick={toggleOverlay}
            aria-haspopup="true"
          >
            <IconAppendix />
          </button>
        )}
      </div>
    </>
  )
}

export const AppendixWaypoint = ({ id, page }) => {
  const pageData = AppendixItems.find(obj => {
    return obj.page === page
  })

  const appendixData = pageData.items.find(item => {
    return item.id === id
  })

  return (
    <VisibilitySensor
      onChange={isVisible => {
        if (isVisible) {
          const Message = () => (
            <div className="appendix__bubble">
              <header>Further Reading</header>
              <a
                href={appendixData.href}
                dangerouslySetInnerHTML={{ __html: appendixData.text }}
              ></a>
            </div>
          )

          toast.info(<Message />, {
            position: toast.POSITION.BOTTOM_RIGHT,
            toastId: slugify(appendixData.text),
          })
        } else {
          toast.dismiss(slugify(appendixData.text))
          toast.clearWaitingQueue()
        }
      }}
    >
      <p
        className="appendix__waypoint"
        aria-controls="appendix__bubble"
        aria-hidden="true"
      ></p>
    </VisibilitySensor>
  )
}
